import { proxy } from 'valtio';

export const currentCreatedTimestampState: Record<string, string | null | undefined> =
  proxy({
    // initialised in services/canvas/src/pages/board/use-board-data.ts
    createdTimestamp: null,
  });
